import { GuestCheckoutControllerApi } from '@luminate/connect-api-client-ts';
import { GuestRegistrationRequestToOTPCreatePatientRequestConverter, OrderDtoToOrderConverter } from './converter';
import { AdminApiClientConfigFactory } from './AdminApiClientConfigFactory';
export class GuestService {
    guestCheckoutApi;
    guestRegistrationRequestToOTPCreatePatientRequestConverter;
    orderDtoConverter;
    static LH_REQUEST_ID_HEADER_NAME = 'lh-request-id';
    static LH_REQUEST_OTP_TTL_HEADER_NAME = 'lh-request-ttl';
    static G_RECAPTCHA_RESPONSE_HEADER_NAME = 'g-recaptcha-response';
    constructor(guestCheckoutApi, guestRegistrationRequestToOTPCreatePatientRequestConverter, orderDtoConverter) {
        this.guestCheckoutApi = guestCheckoutApi;
        this.guestRegistrationRequestToOTPCreatePatientRequestConverter = guestRegistrationRequestToOTPCreatePatientRequestConverter;
        this.orderDtoConverter = orderDtoConverter;
    }
    static create = (apiBaseUrl) => {
        return new GuestService(new GuestCheckoutControllerApi(undefined, apiBaseUrl, AdminApiClientConfigFactory.create(undefined)), GuestRegistrationRequestToOTPCreatePatientRequestConverter.create(), OrderDtoToOrderConverter.create());
    };
    verifyEmail = async (email, recaptcha) => {
        const axiosResponse = await this.guestCheckoutApi.generateEmailOtpUsingPOST({ email }, {
            headers: {
                [GuestService.G_RECAPTCHA_RESPONSE_HEADER_NAME]: recaptcha,
            },
        });
        const otpId = axiosResponse.headers[GuestService.LH_REQUEST_ID_HEADER_NAME];
        const otpTTL = axiosResponse.headers[GuestService.LH_REQUEST_OTP_TTL_HEADER_NAME];
        return {
            id: otpId,
            ttl: otpTTL,
        };
    };
    guestRegistration = async (guestRegistrationRequest) => {
        const { otpId, otpCode } = guestRegistrationRequest;
        await this.guestCheckoutApi.validateEmailOtpUsingPOST(otpCode, otpId, this.guestRegistrationRequestToOTPCreatePatientRequestConverter.toModel(guestRegistrationRequest));
    };
    generateOrderOtp = async (transactionId, url) => {
        const axiosResponse = await this.guestCheckoutApi.generateOrderOtpUsingPOST(transactionId, url);
        const otpId = axiosResponse.headers[GuestService.LH_REQUEST_ID_HEADER_NAME];
        const otpTTL = axiosResponse.headers[GuestService.LH_REQUEST_OTP_TTL_HEADER_NAME];
        return {
            id: otpId,
            ttl: otpTTL,
        };
    };
    validateOrderOtp = async (otpCode, otpId, transactionId) => {
        const axiosResponse = await this.guestCheckoutApi.validateOrderOtpUsingPOST(otpCode, otpId, transactionId);
        return this.orderDtoConverter.toModel(axiosResponse.data);
    };
}
